import { withTranslation } from '@application/i18n/with_translation';
import { Flex, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Shimmer } from '@component/new_shimmer.component';
import { AsyncSignal } from '@cortex-shim/async_signal.component';
import { useResolveController, withNewContainer } from '@visiba/instantiation';
import { EmptyState } from '../_empty_message.component';
import { ReceptionCategories } from './_reception_categories.component';
import { ReceptionList, StyledGrid } from './_reception_list.component';
import { BrowseReceptionsController } from './browse_receptions.controller';

export const BrowseReceptions = withNewContainer(function BrowseReceptions() {
	const controller = useResolveController(BrowseReceptionsController);

	return (
		<Flex gap={tokens.spacing.x3}>
			<Text variant='headingSmall'>{withTranslation('View.FindReception.BrowseReceptions.Title')}</Text>
			<AsyncSignal signal={controller.presentation} pending={<Skeleton />}>
				{(data) => (
					<>
						{data.rootReceptions.length === 0 && data.rootCategories.length === 0 ? (
							<EmptyState>{withTranslation('View.FindReception.BrowseReceptions.EmptyMessage')}</EmptyState>
						) : (
							<Flex gap={tokens.spacing.x3} direction='column'>
								<ReceptionList receptions={data.rootReceptions} />
								<ReceptionCategories categories={data.rootCategories} />
							</Flex>
						)}
					</>
				)}
			</AsyncSignal>
		</Flex>
	);
});

function Skeleton() {
	return (
		<StyledGrid>
			<Shimmer width='100%' height={tokens.spacing.x8} />
			<Shimmer width='100%' height={tokens.spacing.x8} />
			<Shimmer width='100%' height={tokens.spacing.x8} />
		</StyledGrid>
	);
}
